// StringField.jsx
import { TextField } from "@mui/material";
import { formatTitle } from "../utils";

export const StringField = ({
  fieldKey,
  schema,
  value,
  required,
  onChange,
}) => {
  return (
    <TextField
      fullWidth
      multiline={fieldKey.includes("message")}
      rows={fieldKey.includes("message") ? 4 : 1}
      label={formatTitle(fieldKey)}
      placeholder={schema.description}
      value={value || ""}
      disabled={schema?.readOnly || false}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
          borderColor: "primary.main",
        },
      }}
    />
  );
};